import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { Country } from '@nxtpeople/nxt-vue-library';

export class SsnCountryService {
   async getSsnCountries() {
      const response = await http.get<PaginatedResponse<Country>>(`/ssn-countries`, cacheFirstConfig);
      return response.data;
   }
}
